import { Award } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { RewardsRoutes } from "./routes";
import { RewardsPermissions } from "./permissions";

export const rewardsNav: INavItem = {
  labelKey: "nav.rewards",
  icon: Award,
  path: RewardsRoutes.DASHBOARD,
  permissions: [RewardsPermissions.VIEW, RewardsPermissions.VIEW_MEMBERS, RewardsPermissions.VIEW_AUDIT],
  permissionPrefix: "Travel:Rewards:",
  children: [
    { labelKey: "nav.rewards_dashboard", path: RewardsRoutes.DASHBOARD, permissions: [RewardsPermissions.VIEW] },
    { labelKey: "nav.rewards_programs", path: RewardsRoutes.PROGRAMS, permissions: [RewardsPermissions.VIEW] },
    { labelKey: "nav.rewards_tiers", path: RewardsRoutes.TIERS, permissions: [RewardsPermissions.VIEW] },
    { labelKey: "nav.rewards_rules", path: RewardsRoutes.RULES, permissions: [RewardsPermissions.VIEW] },
    {
      labelKey: "nav.rewards_simulator",
      path: RewardsRoutes.SIMULATOR,
      permissions: [RewardsPermissions.MANAGE_RULES],
    },
    {
      labelKey: "nav.rewards_members",
      path: RewardsRoutes.MEMBERS,
      permissions: [RewardsPermissions.VIEW_MEMBERS],
    },
    { labelKey: "nav.rewards_catalog", path: RewardsRoutes.CATALOG, permissions: [RewardsPermissions.VIEW] },
    {
      labelKey: "nav.rewards_redemptions",
      path: RewardsRoutes.REDEMPTIONS,
      permissions: [RewardsPermissions.VIEW],
    },
    { labelKey: "nav.rewards_audit", path: RewardsRoutes.AUDIT, permissions: [RewardsPermissions.VIEW_AUDIT] },
  ],
};
